import React, { useRef, useEffect } from 'react';
import { func, string, bool } from 'prop-types';
import { useAppContext } from 'Scenes/_root/appContext';

import DeviceSettingsBar from 'Elements/DeviceSettingsBar';
import Meeting from 'Elements/Meeting';
import { withMeetingContext, MeetingContextDeviceControlsProps } from 'Scenes/_root/meetingContext';
import DashboardDrawer from './DashboardDrawer';
import styles from './styles.scss';

export const PractitionerDashboard = (props) => {
  const {
    deviceControls,
    openDeviceSettingsModal,
    incomingPatientCode,
    incomingPatientShowError,
    meetingPutPatientDetails,
  } = props;
  const container = useRef(null);
  const { isLoggedIn } = useAppContext();

  useEffect(() => {
    const { audioIn, video } = deviceControls.getSelectedDeviceIds();
    if (!audioIn && !video) {
      openDeviceSettingsModal();
    }
    if (isLoggedIn && incomingPatientCode && !incomingPatientShowError) {
      meetingPutPatientDetails(incomingPatientCode);
    }
  }, []);

  return (
    <div className={styles.dashboardWrapper}>
      <div ref={container} className={styles.main}>
        <Meeting />
        <DashboardDrawer
          container={container.current}
        />
      </div>
      <DeviceSettingsBar />
    </div>
  );
};

PractitionerDashboard.propTypes = {
  incomingPatientCode: string,
  incomingPatientShowError: bool,
  meetingPutPatientDetails: func.isRequired,
  deviceControls: MeetingContextDeviceControlsProps,
  openDeviceSettingsModal: func.isRequired,
};

export default withMeetingContext(['deviceControls'])(PractitionerDashboard);
